import FJArcProgress from '../../../common/components/FJArcProgress/FJArcProgress';
import FJLocalStore from '../../../store/FJLocalStore';
import styles from './FJProgressModal.module.less';
import PropTypes from 'prop-types';

const FJProgressModal = ({ progress, cancel }) => {
    return (
        <div className={styles.progress_modal_box}>
            <FJArcProgress percent={progress} size={90} valueClassName={styles.progress_text} showBackground={true} />

            <div className={styles.progress_modal_text}> {FJLocalStore._('processing')} </div>

            {cancel && (
                <div className={styles.cancel_btn} onClick={cancel}>
                    <span>{FJLocalStore._('cancel')}</span>
                </div>
            )}
        </div>
    );
};

FJProgressModal.propTypes = {
    progress: PropTypes.number.isRequired,
    cancel: PropTypes.func,
};

export default FJProgressModal;
